var CacheMemory = /** @class */ (function () {
    function CacheMemory($q) {
        this.$q = $q;
        this.memory = {};
    }
    CacheMemory.prototype.set = function (key, data) {
        this.memory[key] = this.cloneData(data);
    };
    CacheMemory.prototype.get = function (key) {
        return this.memory[key];
    };
    CacheMemory.prototype.has = function (key) {
        return this.get(key) !== undefined;
    };
    CacheMemory.prototype.getCache = function (key, handleNoCache) {
        var _this = this;
        return this.$q(function (resolve, reject) {
            if (_this.memory[key]) {
                var data = _this.cloneData(_this.memory[key]);
                resolve(data);
            }
            else {
                handleNoCache().then(function (data) {
                    _this.set(key, data);
                    resolve(data);
                    return data;
                }, reject);
            }
        });
    };
    CacheMemory.prototype.remove = function (key) {
        delete this.memory[key];
    };
    CacheMemory.prototype.clean = function () {
        this.memory = {};
    };
    CacheMemory.prototype.cloneData = function (data) {
        return JSON.parse(JSON.stringify(data));
    };
    return CacheMemory;
}());
var CacheMemoryService = /** @class */ (function () {
    function CacheMemoryService($q) {
        this.$q = $q;
        this.cacheList = {};
    }
    CacheMemoryService.prototype.create = function (name) {
        //clean old cache with name
        this.remove(name);
        //create new cache
        this.cacheList[name] = new CacheMemory(this.$q);
        return this.cacheList[name];
    };
    CacheMemoryService.prototype.get = function (name) {
        if (this.cacheList[name])
            return this.cacheList[name];
        else
            return this.create(name);
    };
    CacheMemoryService.prototype.remove = function (name) {
        delete this.cacheList[name];
    };
    CacheMemoryService.prototype.clean = function () {
        var _this = this;
        _.each(this.cacheList, function (name) {
            _this.remove(name);
        });
    };
    return CacheMemoryService;
}());
angular.module('shared').service('CacheMemoryService', ['$q', CacheMemoryService]);
